import gql from 'graphql-tag';

const GET_MODELS = gql`
  query getModels(
    $filter: ModelFilterInput
    $sort: ModelSortInput
    $skip: Int
    $take: Int
  ) {
    getModels(filter: $filter, sort: $sort, skip: $skip, take: $take) {
      models {
        id
        name
        type
        brand {
          id
          name
        }
      }
      aggregate {
        rows
      }
    }
  }
`;

export default {
  GET_MODELS,
};
